 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      GL Account No
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryGlAcctNoFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.branch"
                            :label="filtersGlAcctNoLabel.branch"
                            :error-messages="errors.collect('filterGlAcctNo.branch')"
                            data-vv-name="filterGlAcctNo.branch"
                            :data-vv-as="filtersGlAcctNoLabel.branch"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.glacctNo"
                            :label="filtersGlAcctNoLabel.glacctNo"
                            :error-messages="errors.collect('filterGlAcctNo.glacctNo')"
                            data-vv-name="filterGlAcctNo.glacctNo"
                            :data-vv-as="filtersGlAcctNoLabel.glacctNo"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.description"
                            :label="filtersGlAcctNoLabel.description"
                            :error-messages="errors.collect('filterGlAcctNo.description')"
                            data-vv-name="filterGlAcctNo.description"
                            :data-vv-as="filtersGlAcctNoLabel.description"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12 v-if="objData.transactions !== 'nonTrade'">
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.fund"
                            :label="filtersGlAcctNoLabel.fund"
                            :error-messages="errors.collect('filterGlAcctNo.fund')"
                            data-vv-name="filterGlAcctNo.fund"
                            :data-vv-as="filtersGlAcctNoLabel.fund"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryGlAcctNoFilterForm"
                            v-model="filtersGlAcctNo.acctNoSfx"
                            :label="filtersGlAcctNoLabel.acctNoSfx"
                            :error-messages="errors.collect('filterGlAcctNo.acctNoSfx')"
                            data-vv-name="filterGlAcctNo.acctNoSfx"
                            :data-vv-as="filtersGlAcctNoLabel.acctNoSfx"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearGlAcctNoFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doGlAcctNoFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="glAcctNoHeaders3"
          :items="glAcctNoItems3"
          v-bind:options.sync="paginationGlAcctNo3"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsGlAcctNo3"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.branch }}</td>
              <td>{{ row.item.glacctNo }}</td>
              <td>{{ row.item.fund }}</td>
              <td>{{ row.item.suffix }}</td>
              <td>{{ row.item.description }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignGlAcctNo(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      showGlAcctNoHelpList: false,
      filtersGlAcctNoLabel: {
        glacctNo: 'GL Account No.',
        description: 'Description',
        fund: 'Fund',
        branch: 'Branch',
        acctNoSfx: 'Acct No. Sfx'
      },
      filtersGlAcctNo: {
        glacctNo: undefined,
        description: undefined,
        fund: undefined,
        branch: undefined,
        acctNoSfx: undefined,
        acctNo: undefined,
        transactions: undefined
      },
      glAcctNoHeaders3: [
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'GL Account No.', align: 'left', value: 'glacctNo' },
        { text: 'Fund', align: 'left', value: 'fund' },
        { text: 'AcctNoSfx', align: 'left', value: 'suffix' },
        { text: 'Descption', value: 'description' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationGlAcctNo3: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      glAcctNoItems3: [],
      totalItemsGlAcctNo3: 0
    }
  },
  mounted() {
    this.doClearGlAcctNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersGlAcctNo.branch = ''
      this.filtersGlAcctNo.glacctNo = ''
      if (this.objData !== null) {
        if (this.objData.transactions === 'nonTrade') {
          this.filtersGlAcctNo.fund = this.objData.fund
        }
        this.filtersGlAcctNo.acctNo = this.objData.acctNo
      } else {
        this.filtersGlAcctNo.fund = ''
      }
      this.filtersGlAcctNo.acctNoSfx = ''
      this.filtersGlAcctNo.description = ''
      this.$emit('close')
    },
    doClearGlAcctNoFilters() {
      this.filtersGlAcctNo.branch = ''
      this.filtersGlAcctNo.glacctNo = ''
      this.filtersGlAcctNo.acctNoSfx = ''
      this.filtersGlAcctNo.description = ''
      if (this.objData !== null) {
        this.filtersGlAcctNo.fund = this.objData.fund
        this.filtersGlAcctNo.acctNo = this.objData.fund
        this.filtersGlAcctNo.transactions = this.objData.transactions
      } else {
        this.filtersGlAcctNo.fund = ''
        this.filtersGlAcctNo.acctNo = ''
        this.filtersGlAcctNo.transactions = ''
      }
      this.fetchGlAcctNoData3()
    },
    doGlAcctNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryGlAcctNoFilterForm').then((result) => {
        if (result) {
          this.paginationGlAcctNo3.page = 1
          this.fetchGlAcctNoData3()
        }
      })
    },
    assignGlAcctNo(data) {
      // Use $emit to call parent GL Account No page method assignGlAcctNo and pass the value
      this.$emit('assign-gl-acct-no', data.glacctNo)
      this.$emit('assign-gl-acct-info', data)
      this.$emit('close')
    }
  },
  watch: {
    paginationGlAcctNo3: function (value) {
      this.fetchGlAcctNoData3()
    }
  },
  computed: {},
  mixins: [TableConst.default, commonAjaxMixin],
  props: {
    objData: {
      type: Object,
      default: null
    }
  }
}
</script>
